import { useEffect } from 'react';
import { getAppUrl } from '@drayalliance/utils';

function Edi204List() {
  useEffect(() => {
    window.location.assign(`${getAppUrl(window.location.hostname, 'dms', 3001)}/electronic-data-interchange/204`);
  }, []);

  return null;
}

export default Edi204List;
